require("../../node_modules/jquery-ui/ui/core");
require("../../node_modules/jquery-ui/ui/widget");
require("../../node_modules/jquery-ui/ui/effect");
require("../../node_modules/jquery-ui/ui/widgets/accordion");

module.exports = {
  init: () => {
    const visible = $(window).width() > 480 || window.location.href.indexOf("filterOpen=true") >= 0;
    if (visible === false) {
      $(".expander-content").hide();
    }
    $(".expander").accordion({
      header: ".expander-header",
      collapsible: true,
      active: visible,
    });

    $(window).resize(function () {
      $(".expander").accordion("refresh");
    });

    $(window).on("scroll", function () {
      if ($(".expander").length >= 1) {
        var headerBottom = $(".header").offset().top + $(".header").outerHeight() + $(".expander-button").outerHeight();
        var divBottom = $(".expander").offset().top + $(".expander").outerHeight();
        if (divBottom >= headerBottom) {
          $(".expander-button").removeClass("expander-button--active");
        } else {
          $(".expander-button").addClass("expander-button--active");
        }
      }
    });

    $(".expander-button").click(function () {
      $("html, body")
        .animate({ scrollTop: 0 }, "slow")
        .promise()
        .done(function () {
          $(".expander").accordion("option", "active", 0);
        });
    });
  },
};
